import { usePageContext } from '../../../../providers/PageProvider';
import { ShareLink } from './components/ShareLink';
import { GeneralSection } from './components/GeneralSection';
import { ScheduleSection } from './components/ScheduleSection';
import { MaterialsSection } from './components/MaterialsSection';
import { CommentsSection } from './components/CommentsSection';
import { AssigneeHistorySection } from './components/AssigneeHistorySection';

import { TopRightSection } from './styles/TopRightSection';
import { Divider } from './styles/Divider';
import { PipelineTimestamps } from './components/JobPipelineTimestamps';
import { EnhancementSection } from './components/EnhancementSection';
import { AttachBackupButton } from '@pages/Admin/JobDetailsPage/components/Content/components/MainContent/components/AttachBackupButton';
import { ResubmitButton } from '@pages/Admin/JobDetailsPage/components/Content/components/MainContent/components/ResubmitButton';

export const MainContent = () => {
  const { job, isLoading, enhancements } = usePageContext();

  if (isLoading && !job) {
    return null;
  }
  if (!job) {
    return <h2>Job not found</h2>;
  }

  return (
    <>
      <TopRightSection>
        <ResubmitButton />
        <AttachBackupButton />
        <ShareLink />
      </TopRightSection>

      <GeneralSection />

      <Divider />

      {enhancements ? (
        <>
          <EnhancementSection />
          <Divider />
        </>
      ) : null}

      <ScheduleSection />

      <Divider />

      <MaterialsSection />

      <CommentsSection />

      <AssigneeHistorySection />

      <PipelineTimestamps data={job} />
    </>
  );
};
